import TextEditor from '../../components/textEditor/TextEditor'

const Terms = () => {
    return (
        <TextEditor tag_name="terms_conditions" />
    )
}

export default Terms